"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getVolumeFromGroupId = require("./getVolumeFromGroupId");
Object.keys(_getVolumeFromGroupId).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getVolumeFromGroupId[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _getVolumeFromGroupId[key];
    }
  });
});